import { ISocketNotificationCounter } from '../../services/websockets/types';
import { ICounters } from '../api/models/counters/counters.types';
import { ActionsUnion, createAction } from '../helpers';

export enum ECountersActionType {
  GET = 'COUNTERS/GET',
  GET_SUCCESS = 'COUNTERS/GET_SUCCESS',
  COUNTER_WEBSOCKET_UPDATE = 'COUNTER/WEBSOCKET/UPDATE',
  VISIT_COUNTER_UPDATE = 'COUNTER/VISIT/UPDATE',
  FAVORITE_COUNTER_UPDATE = 'COUNTER/FAVORITE/UPDATE',
  MESSAGE_COUNTER_UPDATE = 'COUNTER/MESSAGE/UPDATE',
  PHOTO_REQUEST_COUNTER_UPDATE = 'COUNTER/PHOTO_REQUEST/UPDATE',
}

export const countersActions = {
  getCounters: () => createAction(ECountersActionType.GET),
  getCountersSuccess: (counters: ICounters) =>
    createAction(ECountersActionType.GET_SUCCESS, counters),
  updateCounterFromWebsocket: (rawNotification: ISocketNotificationCounter) =>
    createAction(ECountersActionType.COUNTER_WEBSOCKET_UPDATE, rawNotification),
  updateFavoriteCounter: (count: number) =>
    createAction(ECountersActionType.FAVORITE_COUNTER_UPDATE, count),
  updateVisitCounter: (count: number) =>
    createAction(ECountersActionType.VISIT_COUNTER_UPDATE, count),
  updateMessageCounter: (count: number) =>
    createAction(ECountersActionType.MESSAGE_COUNTER_UPDATE, count),
  updatePhotoRequestCounter: (count: number) =>
    createAction(ECountersActionType.PHOTO_REQUEST_COUNTER_UPDATE, count),
};

export type ICountersAction = ActionsUnion<typeof countersActions>;
